import { defineMessages } from 'react-intl';
export const dashboardMessages = defineMessages({
    dashboardPageTitle: {
        id: 'DashboardPageTitle',
        defaultMessage: 'Dashboard',
        description: 'Title for page indicating this is the dashboard page',
    },
});
export default dashboardMessages;
